// extracted by mini-css-extract-plugin
module.exports = {"title-link":"Styles_title-link__l7ov_","active":"Styles_active__j109s"};